export interface CompositionDTO {
  compositionId?: number;
  compositionName?: string;
  subscriptionName?: string;
  total?: number;
  pending?: number;
}
